import React from "react"
import PropTypes from "prop-types"
import TextBlock from "components/TextBlock"
import theme from "styles/theme"
import Markdown from "markdown-to-jsx"

const componentMobile = "@media (max-width: 630px)"

const IconCards = ({ reverseDesktopLayout, title, description, cards }) => (
  <div
    css={{
      maxWidth: 942,
      margin: "60px auto 0",
      display: "grid",
      gridTemplateColumns: "4fr 3fr 3fr",
      gridGap: 38,
      direction: reverseDesktopLayout ? "rtl" : "ltr",
      [theme.tablet]: {
        gridTemplateColumns: "1fr 1fr",
        gridGap: "15px 20px",
      },
      [componentMobile]: {
        gridTemplateColumns: "1fr",
      },
    }}
  >
    <div
      css={{
        gridRow: `1 / ${Math.ceil(cards.length / 2) + 1}`,
        [theme.tablet]: { gridRowEnd: cards.length + 1 },
        [componentMobile]: { gridRowEnd: "auto" },
        direction: "ltr",
      }}
    >
      <h3 css={{ ...theme.t4 }}>{title}</h3>
      <TextBlock>{description}</TextBlock>
    </div>

    {cards.map(({ icon, title, content }, index) => (
      <div
        key={index}
        css={{
          padding: 26,
          background: theme.white,
          borderBottom: `8px solid ${theme.midBlue}`,
          direction: "ltr",
          [theme.tablet]: {
            padding: 20,
            borderBottomWidth: 6,
          },
        }}
      >
        <h4
          css={{
            ...theme.t5md,
            display: "flex",
            alignItems: "center",
            color: theme.midBlue,
          }}
        >
          <Markdown
            css={{
              width: 24,
              marginRight: 12,
              path: { stroke: "currentColor" },
            }}
          >
            {icon.asset.svg.content}
          </Markdown>
          {title}
        </h4>

        <p css={{ ...theme.previewText, color: theme.gray, marginBottom: 0 }}>
          {content}
        </p>
      </div>
    ))}
  </div>
)

export default IconCards

IconCards.propTypes = {
  reverseDesktopLayout: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.array.isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        asset: PropTypes.shape({
          svg: PropTypes.shape({
            content: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    })
  ),
}
